module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.f0769e37.jpg";